import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconUndo = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M7.383 4.242c.14.14.203.32.187.54 0 .202-.07.374-.21.515L4.733 7.78h10.547c.922 0 1.79.18 2.602.54a6.9 6.9 0 0 1 2.156 1.452 6.65 6.65 0 0 1 1.43 2.133c.36.828.539 1.703.539 2.625v4.711a.693.693 0 0 1-.235.54.701.701 0 0 1-.515.21.782.782 0 0 1-.54-.21.73.73 0 0 1-.21-.54v-4.71c0-.72-.14-1.4-.422-2.04a4.899 4.899 0 0 0-1.125-1.664 5.474 5.474 0 0 0-1.64-1.125 5.017 5.017 0 0 0-2.04-.422H4.734L7.36 11.79c.141.14.211.32.211.54a.628.628 0 0 1-.187.515.75.75 0 0 1-.516.258.741.741 0 0 1-.539-.235l-4.172-3.96a.444.444 0 0 1-.164-.352.47.47 0 0 1 .164-.375l4.172-3.985a.697.697 0 0 1 .54-.187c.202 0 .374.078.515.234z" }),
});

export { IconUndo };
